export type LlmModelMeta = {
  name: string;
  short: string;
  color: string;
  icon: string;
};

export const LLM_MODELS: LlmModelMeta[] = [
  { name: 'ChatGPT', short: 'Ch', color: '#10a37f', icon: '/images/llms/chatgpt.svg' },
  { name: 'Gemini', short: 'Ge', color: '#4285f4', icon: '/images/llms/gemini.svg' },
  { name: 'Claude', short: 'Cl', color: '#d4a27f', icon: '/images/llms/claude.svg' },
  { name: 'Perplexity', short: 'Pe', color: '#1a73e8', icon: '/images/llms/perplexity.svg' },
];

export const getLlmMeta = (model: string): LlmModelMeta =>
  LLM_MODELS.find((entry) => entry.name.toLowerCase() === model.toLowerCase()) || {
    name: model,
    short: model.slice(0, 2).toUpperCase(),
    color: '#807a79',
    icon: '',
  };
